import './bml-news-article.scss';
import { fetchWithAccessCheck, formatDate } from '../../dynamic-page/page-access';
import { loadContentForNewElements } from '../../content-editor-src';

const TEMPLATE = `
<section class="article-content fade-up">
    <div class="article-inner">
        <div class="row">
            <div class="col-md-6" data-animate-child>
                <p id="dynamic-date" data-content="" data-global="true"></p>
            </div>
            <div class="col-md-6">
                <h1 id="dynamic-title" data-animate-child data-content="" data-global="true"></h1>
                <p id="dynamic-description" data-animate-child data-content="" data-type="textarea"
                   data-global="true"></p>
            </div>
        </div>
    </div>
    <img id="dynamic-main-image"
         src=""
         class="news-main-image"
         alt=""
         data-content=""
         data-type="image"
         data-global="true"
         data-animate-child>
    <div class="article-inner">
        <section id="news-content" class="news-content fade-up" data-section="news-content"
                 data-animate-child>
        </section>
    </div>
</section>
`;

function buildContentMapping(slug) {
    if (slug.startsWith('case-')) {
        return [
            { id: 'dynamic-date',        contentId: `${slug}-date` },
            { id: 'dynamic-title',       contentId: `${slug}-title` },
            { id: 'dynamic-description', contentId: `${slug}-problem` },
            { id: 'dynamic-main-image',  contentId: `${slug}-cases-image` },
        ];
    }
    return [
        { id: 'dynamic-date',        contentId: `${slug}-date` },
        { id: 'dynamic-title',       contentId: `${slug}-title` },
        { id: 'dynamic-description', contentId: `${slug}-description` },
        { id: 'dynamic-main-image',  contentId: `${slug}-image` },
    ];
}

class BmlNewsArticle extends HTMLElement {
    connectedCallback() {
        if (!this.innerHTML.trim()) this.innerHTML = TEMPLATE;

        const path = window.location.pathname;
        const pathMatch = path.match(/\/(?:news|case)\/([^/]+)/);
        const slug = pathMatch ? pathMatch[1] : new URLSearchParams(window.location.search).get('slug');
        if (!slug) return;

        if (slug.startsWith('case-')) {
            const dateEl = this.querySelector('#dynamic-date');
            if (dateEl) dateEl.style.display = 'none';
        }

        this._applyContentIds(slug);
        this._loadData(slug);
    }

    _applyContentIds(slug) {
        const isCase = slug.startsWith('case-');

        buildContentMapping(slug).forEach(({ id, contentId }) => {
            const el = this.querySelector(`#${id}`);
            if (el) el.setAttribute('data-content', contentId);
        });

        const newsContent = this.querySelector('#news-content');
        if (newsContent) {
            newsContent.setAttribute('data-page', `${isCase ? 'Case' : 'News'} - ${slug}`);
        }
    }

    async _loadData(slug) {
        const isCase = slug.startsWith('case-');
        const data = await fetchWithAccessCheck(
            isCase ? `/api/cases/slug/${slug}` : `/api/news/slug/${slug}`,
            isCase ? 'case' : 'news'
        );

        if (data) {
            const titleEl = this.querySelector('#dynamic-title');
            // Only overwrite document.title when SSR didn't already fill the title element.
            // If SSR rendered it, the <title> tag is already correct; setting entity.title
            // here would cause a flash from "Content Title" → "1" → "Content Title".
            if (!titleEl?.textContent?.trim()) {
                document.title = `${data.title} - BML${isCase ? ' Cases' : ''}`;
            }

            // Only update data-page if SSR didn't inject a specific page title already
            const curPage = document.body.getAttribute('data-page') || '';
            if (!curPage || curPage === 'News' || curPage === 'News-feed') {
                document.body.setAttribute('data-page', `${isCase ? 'Case' : 'News'} - ${data.title}`);
            }

            if (!isCase) {
                const dateEl = this.querySelector('#dynamic-date');
                if (dateEl && !dateEl.textContent.trim()) {
                    dateEl.textContent = formatDate(data.published_at || data.created_at);
                }
            }
            if (titleEl && !titleEl.textContent.trim()) {
                titleEl.textContent = data.title;
            }
            const descEl = this.querySelector('#dynamic-description');
            if (descEl && !descEl.textContent.trim()) {
                descEl.textContent = isCase ? 'Детальний опис кейсу' : (data.preview_text || '');
            }
        }

        loadContentForNewElements([...this.querySelectorAll('[data-content]')]);

        // After the content editor applies its values, sync document.title with the
        // actual rendered title element (works for both SSR and pure-JS paths).
        setTimeout(() => {
            const titleEl = this.querySelector('#dynamic-title');
            const rendered = titleEl?.textContent?.trim();
            if (rendered) document.title = `${rendered} - BML${isCase ? ' Cases' : ''}`;
        }, 350);
    }
}

customElements.define('bml-news-article', BmlNewsArticle);
